module.exports = __webpack_public_path__ + "img/linkedin.51e0318b.svg";